module.exports = __webpack_public_path__ + "img/absen.bc97cb55.png";